import Swal from 'sweetalert2';

export default function successSwal(swalText: string) {
  Swal.fire({
    icon: 'success',
    title: `<h4 class="nk-modal-title">${swalText}<br></h4>`,
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    showCancelButton: false,
    confirmButtonColor: '#6576FF',
  });
}
